import { BaseDto } from "@/shared/dtos/base-dto";
import { empresa } from "./empresa";

export class departamento extends BaseDto {
  public nombre!: string;
  public ubicacion!: string;
  public id_empresa!: number;
  public empresa!: empresa;
}
